import { useLocation, useNavigate } from 'react-router-dom';
import { sentryLog } from '../Utils/SentryLog';
import { getLqzyParams } from '../Utils/GetLqzyParams';
import axios from 'axios';
import { toast } from 'react-toastify';

const isShowConsole = process.env.NODE_ENV === 'development';

const lemonSqzyQueryParams = getLqzyParams();

function BillingPage({userDetails, isIndianUser, forSheetsExtension}){

    const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

    const isCancelledUser = userDetails.isPremium && userDetails.isCancelled;
    const isExtCancelledUser = userDetails.isExtPremium && userDetails.isExtCancelled;
    const isTrialUser = userDetails.isPremium && userDetails.isTrialPlan;
    const isLifetimeUser = userDetails.planType === 'Lifetime';

    const location = useLocation();
    const navigate = useNavigate(); 

    const purchaseDate = (userDetails.isExtPremium && forSheetsExtension) ? new Date(userDetails.extLastBilled).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : userDetails.isPremium ? new Date(userDetails.premiumSince).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : '';

    const subscriptionId = userDetails.subscriptionId;

    const nextBillingDate = (userDetails.isExtPremium && forSheetsExtension) ? new Date(userDetails.extNextBilling) : new Date(userDetails.nextBilling);

    let expiryDate = "", formattedExpiryDate = "";

    if(isCancelledUser){
        expiryDate = new Date(userDetails.validTill);
        formattedExpiryDate = expiryDate.toLocaleDateString('en-GB', {
                                                                day: 'numeric',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            });
    }
    if(isExtCancelledUser && forSheetsExtension){
        expiryDate = new Date(userDetails.extValidTill);
        formattedExpiryDate = expiryDate.toLocaleDateString('en-GB', {
                                                                day: 'numeric',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            });
    }

    isShowConsole && console.log('billing page incoming prop: ', subscriptionId);

    const premiumSince = new Date(userDetails.premiumSince);
    const validTill = new Date(premiumSince);
    const validity = userDetails.planType === 'Pro Weekly' ? 7 : userDetails.planType === 'Pro Monthly' ? 30 : userDetails.planType === 'Pro Yearly' ? 365 : 0; 
    validTill.setDate(validTill.getDate() + (validity));

    const formattedValidTill = userDetails.planType === 'Lifetime' ? 'Lifetime' : validTill.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
    });

    const formattedNextBillingDate = nextBillingDate == "Invalid Date" ? formattedValidTill : userDetails.planType === 'Lifetime' ? 'NA (Lifetime Validity)' : nextBillingDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
    });

    const amountPaid = userDetails.planType === 'Pro Weekly' ? "$2" : userDetails.planType === 'Pro Monthly' ? "$4" : userDetails.planType === 'Pro Yearly' ? "$33" : userDetails.planType === 'Lifetime' ? '$99' : 0;

    const openContactForm = e => {
        try{
            navigate(`/${forSheetsExtension ? 'sheets-extension-contact-us' : 'contact-us'}${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in openContactForm method: ', err);
            sentryLog(`PricingPage.js - openContactForm failed: ${err?.message || err} | user: ${JSON.stringify(userDetails)}`);
        }
    }

    const showErrorToast = e => {
        try{
            toast.error(
            <div className='paymentFailureToast'>
                <span> 
                Something went wrong. Please try again, or <a href="#" onClick={(e) => { e.preventDefault(); openContactForm();}}>Contact Support</a> for help.
                </span>
            </div>,
            {
                className: "paymentFailureToastContainer",
                autoClose: 4000, 
                closeButton: false
            }
            );
        }catch(err){
            isShowConsole && console.error("error in showErrorToast: ", err);
            sentryLog(`BillingPage.js - showErrorToast failed: ${err?.message || err}`);
        }
    }

    const openPricingPage = e => {
        try{
            const query = getLqzyParams();
            navigate(`/${forSheetsExtension ? 'sheets-extension-pricing' : 'pricing'}${query}`);
        }catch(err){
            isShowConsole && console.error('error in openPricingPage method: ', err);
            sentryLog(`BillingPage.js - openPricingPage failed: ${err?.message || err}`);
        }
    }

    const handleManageSubscription = async(e) => {
        try{
            const params = {
                forSheetsExtension: forSheetsExtension
            };

            const res = await axios.get(`${API_BASE_URL}/api/get-customer-portal-link`, { withCredentials: true, params: params });
            
            let customerPortalUrl = res?.data?.portalUrl;
            if(customerPortalUrl){
                window.open(customerPortalUrl, '_blank');
            }
        }catch(err){
            isShowConsole && console.error('error in handleManageSubscription method: ', err);
            showErrorToast();
            sentryLog(`BillingPage.js - handleManageSubscription failed: ${err?.message || err}`);
        }
    }

    return(
        
        (userDetails.isPremium && !forSheetsExtension) ? 
        <div className='billingPage'>
            <div className='pageTitle'>Billing Details</div>
            <div className='pageContent'>
                <div className='detail'>
                    <div className='prop'>Plan purchased:</div>
                    <div className='val'>{userDetails.planType}</div>
                </div>
                <div className='detail'>
                    <div className='prop'>Last billed:</div>
                    <div className='val'>{isTrialUser ? "NA" : purchaseDate}</div>
                </div>
                {isLifetimeUser ? <div className='detail last'>
                    <div className='prop'>Valid till:</div>
                    <div className='val'>{formattedValidTill}</div>
                </div> : isCancelledUser ? <div className='detail last'>
                    <div className='prop'>Valid till:</div>
                    <div className='val'>{formattedExpiryDate ? formattedExpiryDate : formattedValidTill}</div>
                </div> : <div className='detail last'>
                    <div className='prop'>Renews at:</div>
                    <div className='val'>{formattedNextBillingDate ? formattedNextBillingDate : formattedValidTill}</div>
                </div>}
                {!isLifetimeUser && !isTrialUser && <div className='manageSubscriptionDiv'>
                    <button onClick={handleManageSubscription}>{isCancelledUser ? "Resume Subscription" : "Manage Subscription"}</button>
                </div>}
            </div>
        </div> 
        : (userDetails.isExtPremium && forSheetsExtension) ? 
        <div className='billingPage'>
            <div className='pageTitle'>Billing Details</div>
            <div className='pageContent'>
                <div className='detail'>
                    <div className='prop'>Plan purchased:</div>
                    <div className='val'>{userDetails.extPlan}</div>
                </div>
                <div className='detail'>
                    <div className='prop'>Last billed:</div>
                    <div className='val'>{purchaseDate}</div>
                </div>
                {isExtCancelledUser ? <div className='detail last'>
                    <div className='prop'>Valid till:</div>
                    <div className='val'>{formattedExpiryDate ? formattedExpiryDate : formattedValidTill}</div>
                </div> : <div className='detail last'>
                    <div className='prop'>Renews at:</div>
                    <div className='val'>{formattedNextBillingDate ? formattedNextBillingDate : formattedValidTill}</div>
                </div>}
                {<div className='manageSubscriptionDiv'>
                    <button onClick={handleManageSubscription}>{isExtCancelledUser ? "Resume Subscription" : "Manage Subscription"}</button>
                </div>}
            </div>
        </div>
        :
        <div className='billingPage'>
            {forSheetsExtension ? <div className='pageContent free'>
                <div className='freeUserMsgDiv'>
                    <div>Not on a subscription yet?</div>
                    <div>Get monthly credits at lower price with our <span className='cta' onClick={openPricingPage}>Subscription Plans</span></div>
                </div>
            </div> : <div className='pageContent free'>
                <div className='freeUserMsgDiv'>
                    <div>You’re currently on the Free plan</div>
                    <div>Unlock unlimited extractions with our <span className='cta' onClick={openPricingPage}>Premium Plans</span></div>
                </div>
            </div>}
        </div>
    )
}

export default BillingPage;